import React from 'react';
//const Dashboard = React.lazy(() => import('../pages/container/layout'));
import Dashboard from '../pages/container/layout'
var indexRoutes = [{ path: "/", name: "Home", component: Dashboard }];

export default indexRoutes;
